import {serializeMarkdown} from './serialize-markdown'

export function markdownLink(text: string, url: string): string {
  return serializeMarkdown({
    type: 'link',
    children: [{type: 'text', value: text}],
    url,
  })
}

export function markdownImage(alt: string, src: string): string {
  return serializeMarkdown({
    type: 'image',
    alt,
    url: src,
  })
}
